import { cn } from "../../lib/utils"

/**
 * A loading placeholder (spec 2026-09-17-06).
 *
 * shadcn's default is `animate-pulse` — a grey block fading in and out. On a
 * surface-with-shadow design that reads as *broken*, not as *loading*: nothing
 * else on the page breathes. A shimmer sweep reads as work in progress, which
 * is what it is. The sweep is `motion-safe:` only; under
 * `prefers-reduced-motion: reduce` the block is static (`.skeleton-shimmer`
 * and its keyframes live in `index.css`, next to `row-highlight-pulse`).
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "skeleton-shimmer bg-accent relative overflow-hidden rounded-md",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
